import React, {Component} from 'react';
import {withRouter, Switch, Route, Redirect, NavLink} from 'react-router-dom';
import {connect} from 'react-redux';
import {Button} from 'reactstrap';
import Header from '../../../04-containers/Header';
import {logout} from '../../../01-actions/auth';
import './style.css';
import Dashboard from './Dashboard';
import CategoriesPage from './Categories';
import ProductsPage from "./Products/index";
import ImagesPage from "./Images/index";
import Footer from "../../Footer/index";

class AdminPage extends Component {
	constructor(props) {
		super(props);
		this.handleLogout = this.handleLogout.bind(this);
	}
	
	handleLogout() {
		this.props.logout();
	}
	
	render() {
		return (
			<div className="pages-admin">
				{!this.props.user &&
				<Redirect to="/auth/login"/>
				}
				<div>
					<Header to="/" logoOnly={true} subTitle="Admin management panel"/>
				</div>
				<div className="padding">
					<div className="admin-nav-bar">
						<div className="nav">
							<NavLink exact to="/admin">Dashboard</NavLink>
							<NavLink to="/admin/categories">Categories</NavLink>
							<NavLink to="/admin/products">Products</NavLink>
							<NavLink to="/admin/images">Images</NavLink>
						</div>
						<div className="right-side">
							<Button onClick={this.handleLogout}>Logout</Button>
						</div>
					</div>
					
					<Switch>
						<Route exact path="/admin" component={Dashboard}/>
						<Route path="/admin/categories" component={CategoriesPage}/>
						<Route path="/admin/products" component={ProductsPage}/>
						<Route path="/admin/images" component={ImagesPage}/>
						<Redirect to="/error/404"/>
					</Switch>
				</div>
				<Footer/>
			</div>
		);
	}
}


const mapStateToProps = (store) => {
	return {
		user: store.auth.user
	}
};


const mapDispatchToProps = (dispatch) => {
	return {
		logout: () => {
			dispatch(logout());
		}
	}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminPage));


// WEBPACK FOOTER //
// ./src/04-containers/_pages/Admin/index.js